export const SUBSCRIPTION_TIERS = ["free", "plus", "pro"] as const;
export type SubscriptionTier = (typeof SUBSCRIPTION_TIERS)[number];

// Build-time bundle UI/email: только локали с готовыми переводами.
// Активация нового языка = добавить код сюда В ТОЙ ЖЕ фазе, что и JSON/Novu.
// Целевые 20 (seed): белорусский убран 2026-10-04 (OXEM-542) — русский покрывает его целиком.
// Порядок значим: первый = основной язык сервиса (английский).
export const SUPPORTED_LOCALES = [
	"en",
	"az",
	"de",
	"el",
	"es",
	"fr",
	"hi",
	"hu",
	"hy",
	"it",
	"ka",
	"kk",
	"lv",
	"pl",
	"pt",
	"ru",
	"tr",
	"uk",
	"uz",
	"zh",
] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];

/** Полный целевой набор ISO-кодов продукта (seed / roadmap). Не путать с SUPPORTED_LOCALES. */
export const TARGET_LOCALES = [
	"en",
	"az",
	"de",
	"el",
	"es",
	"fr",
	"hi",
	"hu",
	"hy",
	"it",
	"ka",
	"kk",
	"lv",
	"pl",
	"pt",
	"ru",
	"tr",
	"uk",
	"uz",
	"zh",
] as const;
export type TargetLocale = (typeof TARGET_LOCALES)[number];

// Язык по умолчанию / fallback, когда локаль пользователя не определена/не поддержана.
export const DEFAULT_LOCALE: Locale = "en";

/**
 * Снятые с поддержки языки → язык-заменитель (OXEM-542, решение владельца 2026-10-04).
 * Старые клиенты, ссылки, query-параметры и заголовки со снятым кодом принимаются
 * как заменитель, без ошибок. Единственная таблица на сервер и клиент.
 */
export const LOCALE_ALIASES: Readonly<Record<string, Locale>> = { be: "ru" };

/** Снятый код → заменитель (`be` → `ru`); остальные значения возвращаются как есть. */
export function resolveLocaleAlias<T extends string | null | undefined>(value: T): T | Locale {
	if (typeof value !== "string") return value;
	const lang = value.split("-")[0] ?? "";
	const alias = LOCALE_ALIASES[lang.toLowerCase()];
	// Регион белорусского (`be-BY`) заменителю не передаём: `ru-BY` — не код продукта.
	return alias !== undefined ? alias : (value as T);
}

/** Type guard: является ли строка одной из поддерживаемых локалей. */
export function isSupportedLocale(value: unknown): value is Locale {
	return typeof value === "string" && (SUPPORTED_LOCALES as readonly string[]).includes(value);
}

/**
 * Нормализует произвольный код локали к поддерживаемому.
 * Принимает регион-варианты ("en-US" → "en", "ru-RU" → "ru"). Fallback → DEFAULT_LOCALE.
 */
export function normalizeLocale(value: string | null | undefined): Locale {
	if (!value) return DEFAULT_LOCALE;
	const base = resolveLocaleAlias(value.toLowerCase().split("-")[0]);
	return isSupportedLocale(base) ? base : DEFAULT_LOCALE;
}

/**
 * Парсит HTTP-заголовок Accept-Language и выбирает лучший поддерживаемый язык по q-весам.
 * Пример: "ru-RU,ru;q=0.9,en;q=0.8" → "ru". Если ни один не поддержан → DEFAULT_LOCALE.
 */
export function parseAcceptLanguage(header: string | null | undefined): Locale {
	if (!header) return DEFAULT_LOCALE;
	const ranked = header
		.split(",")
		.map((part) => {
			const segments = part.trim().split(";");
			const tag = segments[0] ?? "";
			const qParam = segments.slice(1).find((p) => p.trim().startsWith("q="));
			const q = qParam ? Number.parseFloat(qParam.trim().slice(2)) : 1;
			const base = resolveLocaleAlias(tag.trim().toLowerCase().split("-")[0] ?? "");
			return { base, q: Number.isNaN(q) ? 0 : q };
		})
		.filter((entry) => entry.base.length > 0)
		.sort((a, b) => b.q - a.q);

	for (const { base } of ranked) {
		if (isSupportedLocale(base)) return base;
	}
	return DEFAULT_LOCALE;
}

export const MATERIAL_KINDS = ["pdf", "image", "audio", "video", "text", "url"] as const;
export type MaterialKind = (typeof MATERIAL_KINDS)[number];
